var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"d-flex flex-column flex-grow-1 py-3",staticStyle:{"height":"100%"},attrs:{"align-h":"center"}},[_c('b-col',{staticClass:"text-center"},[(_vm.showConfirm)?_c('ConfirmPerson'):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }